export default function NovoModelo() {
  const promessas = [
    { icon: 'ri-shield-check-line', text: 'Identifique os sinais antes da crise acontecer' },
    { icon: 'ri-heart-pulse-line', text: 'Reduza as crises de agitação e confusão em casa' },
    { icon: 'ri-sun-line', text: 'Recupere a calma e a previsibilidade na rotina' },
  ];

  return (
    <section className="py-16 sm:py-24 bg-teal-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">

        {/* Label */}
        <span className="inline-block text-xs font-bold tracking-widest text-teal-200 uppercase mb-4">
          Você já viu as provas
        </span>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
          Agora é a sua vez de
          {' '}<span className="text-teal-200">parar de apagar incêndios</span>
          {' '}e começar a prevenir
        </h2>

        {/* Subheadline */}
        <p className="text-teal-100 text-lg sm:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Famílias que aplicaram o protocolo relatam menos conflitos, mais calma
          e uma rotina completamente diferente em poucas semanas.
        </p>

        {/* Promessas rápidas */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-12">
          {promessas.map((p, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-500/40 rounded-full flex-shrink-0">
                <i className={`${p.icon} text-teal-200 text-lg`}></i>
              </div>
              <p className="text-teal-100 text-sm sm:text-base text-left">{p.text}</p>
            </div>
          ))}
        </div>

        {/* Preço + Botão */}
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 sm:p-10 max-w-lg mx-auto">
          <p className="text-teal-200 text-sm line-through mb-1">De R$ 197,00</p>
          <div className="flex items-center justify-center gap-3 mb-1">
            <p className="text-5xl font-bold text-white">R$ 87,90</p>
          </div>
          <p className="text-teal-200 text-sm mb-6">ou 12x de R$ 9,09 no cartão</p>

          <a
            href="https://pay.hotmart.com/U103348916W?checkoutMode=10"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-white hover:bg-teal-50 text-teal-700 font-bold px-8 py-5 rounded-xl text-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Quero acessar o protocolo agora
          </a>

          <div className="flex items-center justify-center gap-2 mt-4">
            <i className="ri-lock-fill text-teal-300 text-sm"></i>
            <span className="text-teal-200 text-xs">Acesso imediato · Pagamento 100% seguro</span>
          </div>
        </div>

      </div>
    </section>
  );
}
